/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ImportTask } from "./ImportTask";
import {
  ImportTaskFromJSON,
  ImportTaskFromJSONTyped,
  ImportTaskToJSON,
  ImportTaskToJSONTyped,
} from "./ImportTask";

/**
 *
 * @export
 * @interface ApiImporttasksList200Response
 */
export interface ApiImporttasksList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiImporttasksList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiImporttasksList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiImporttasksList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<ImportTask>}
   * @memberof ApiImporttasksList200Response
   */
  results: Array<ImportTask>;
}

/**
 * Check if a given object implements the ApiImporttasksList200Response interface.
 */
export function instanceOfApiImporttasksList200Response(
  value: object
): value is ApiImporttasksList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiImporttasksList200ResponseFromJSON(json: any): ApiImporttasksList200Response {
  return ApiImporttasksList200ResponseFromJSONTyped(json, false);
}

export function ApiImporttasksList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiImporttasksList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(ImportTaskFromJSON),
  };
}

export function ApiImporttasksList200ResponseToJSON(json: any): ApiImporttasksList200Response {
  return ApiImporttasksList200ResponseToJSONTyped(json, false);
}

export function ApiImporttasksList200ResponseToJSONTyped(
  value?: ApiImporttasksList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(ImportTaskToJSON),
  };
}
